import { Task, StudyPhase, Resource } from '../types';

export const STUDY_PHASES: StudyPhase[] = [
  { name: 'Foundation', startWeek: 1, endWeek: 8, color: '#E3F2FD' },
  { name: 'Acceleration', startWeek: 9, endWeek: 16, color: '#E8F5E9' },
  { name: 'Interview Ready', startWeek: 17, endWeek: 24, color: '#FFF9C4' }
];

export const CATEGORY_COLORS = {
  'dsa': '#E3F2FD',
  'system-design': '#E8F5E9',
  'cs-fundamentals': '#FFF9C4',
  'project': '#F3E5F5',
  'mock-interview': '#FCE4EC'
};

const DSA_RESOURCES: Resource[] = [
  { id: 'dsa1', title: 'LeetCode Patterns', url: 'https://leetcode.com/discuss/study-guide/458695/', type: 'article' },
  { id: 'dsa2', title: 'NeetCode YouTube', url: 'https://www.youtube.com/c/NeetCode', type: 'video' },
  { id: 'dsa3', title: 'Blind 75 Problems', url: 'https://leetcode.com/discuss/interview-question/460599/', type: 'problem' }
];

const SYSTEM_DESIGN_RESOURCES: Resource[] = [
  { id: 'sd1', title: 'System Design Primer', url: 'https://github.com/donnemartin/system-design-primer', type: 'article' },
  { id: 'sd2', title: 'Designing Data-Intensive Applications', url: 'https://dataintensive.net/', type: 'article' },
  { id: 'sd3', title: 'High Scalability', url: 'http://highscalability.com/', type: 'article' }
];

const CS_FUNDAMENTALS_RESOURCES: Resource[] = [
  { id: 'cs1', title: 'Operating Systems - Three Easy Pieces', url: 'https://pages.cs.wisc.edu/~remzi/OSTEP/', type: 'article' },
  { id: 'cs2', title: 'Computer Networks - Top Down Approach', url: 'https://gaia.cs.umass.edu/kurose_ross/index.php', type: 'article' },
  { id: 'cs3', title: 'Database Systems Concepts', url: 'https://www.db-book.com/', type: 'article' }
];

export function generateDailyTasks(date: Date): Task[] {
  const dayOfWeek = date.getDay();
  const weekNumber = getWeekNumber(date);
  const tasks: Task[] = [];

  // DSA Problems (5 per day on weekdays, 3 on weekends)
  const dsaCount = dayOfWeek === 0 || dayOfWeek === 6 ? 3 : 5;
  for (let i = 0; i < dsaCount; i++) {
    tasks.push({
      id: `dsa-${date.toISOString()}-${i}`,
      title: `DSA Problem ${i + 1}`,
      category: 'dsa',
      completed: false,
      resources: DSA_RESOURCES
    });
  }

  // System Design Topic (daily)
  tasks.push({
    id: `sd-${date.toISOString()}`,
    title: 'System Design Topic',
    category: 'system-design',
    completed: false,
    resources: SYSTEM_DESIGN_RESOURCES
  });

  // CS Fundamentals (daily)
  tasks.push({
    id: `cs-${date.toISOString()}`,
    title: 'CS Fundamentals Review',
    category: 'cs-fundamentals',
    completed: false,
    resources: CS_FUNDAMENTALS_RESOURCES
  });

  // Project Work (3 times per week)
  if ([1, 3, 5].includes(dayOfWeek)) {
    tasks.push({
      id: `proj-${date.toISOString()}`,
      title: 'Project Development',
      category: 'project',
      completed: false,
      resources: []
    });
  }

  // Mock Interview (once per week on Sundays after week 4)
  if (dayOfWeek === 0 && weekNumber > 4) {
    tasks.push({
      id: `mock-${date.toISOString()}`,
      title: 'Mock Interview Practice',
      category: 'mock-interview',
      completed: false,
      resources: []
    });
  }

  return tasks;
}

export function getWeekNumber(date: Date): number {
  const startDate = new Date(2025, 6, 1); // July 1, 2025
  const diffTime = Math.abs(date.getTime() - startDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.floor(diffDays / 7) + 1;
}

export function getPhaseForWeek(weekNumber: number): StudyPhase {
  for (const phase of STUDY_PHASES) {
    if (weekNumber >= phase.startWeek && weekNumber <= phase.endWeek) {
      return phase;
    }
  }
  return STUDY_PHASES[2]; // Default to Interview Ready
}